export default __webpack_public_path__ + "static/media/17.699d9ca8.jpg";